/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, Form } from 'semantic-ui-react';
import shortid from 'short-id';
import _ from 'lodash';
import { toast } from 'react-toastify';

import generatePdfAsync from '../../../services/PDFManager';
import getFullNameOrUserName from '../../../utils/user';
import * as AppActions from '../../../actions';
import * as presentationBuilderDB from '../../../database/PresentationBuilderDB';
// import ModalEmail from '../ModalEmail';
import ModalShareLink from './ModalShareLink';

class SharePresentationEmail extends Component {
  constructor() {
    super();
    this.state = {
      shareLink: '',
      presentation: {
        data: {},
        url: ''
      },
      selectedWeeks: 7,
      emailTemplate: ''
    };
  }

  componentDidMount() {
    this.getEmailTemplate();
    this.fillWeeks();
  }

  onCloseEmailModal = () => {
    this.setState({ showEmailModal: false });
  };

  closeForm = () => {
    this.setState({ showForm: false });
  };

  onWeekSelect = (event, data) => {
    this.setState({
      selectedWeeks: data.value
    });
  };

  getEmailTemplate = async () => {
    const client = window.__APOLLO_CLIENT__;
    const queryResult = await client.query({
      query: presentationBuilderDB.EmailTemplateByNameQuery,
      variables: { name: 'ShareLinkTemplate' }
    });
    if (queryResult.data.emailTemplate.nodes[0]) {
      this.setState({
        emailTemplate: queryResult.data.emailTemplate.nodes[0].content
      });
    }
  };

  customizeShareLink = async () => {
    // await window.__APOLLO_CLIENT__.resetStore();
    this.props.handleShowCheckboxes();
  };

  fillWeeks = () => {
    const weeks = [
      { key: 1, text: '1 week', value: 7 },
      { key: 2, text: '2 weeks', value: 14 },
      { key: 3, text: '3 weeks', value: 21 },
      { key: 4, text: '4 weeks', value: 28 },
      { key: 5, text: '3 months', value: 90 },
      { key: 6, text: '6 months', value: 180 }
    ];

    this.setState({
      weeksOptions: weeks
    });
  };

  showEmailModal = async () => {
    await this.saveOrUpdatedPresentation();
    this.setState({ showEmailModal: true });
  };

  emptyAds = () => this.props.selectedAds.length === 0;

  submitForm = async (event) => {
    const emptyAds = this.props.showCheckboxes && this.emptyAds();
    if (emptyAds) {
      this.setState({ showEmptyAdsMessage: true });
      setTimeout(() => {
        this.setState({ showEmptyAdsMessage: false });
      }, 5000);
      return;
    }
    this.setState({ showEmptyAdsMessage: false });

    event.preventDefault();
    await this.saveOrUpdatedPresentation();
    this.setState({ showForm: true });
  };

  saveOrUpdatedPresentation = async () => {
    const presentationData = {};
    const presentationTitleCustom = this.props.showCheckboxes
      ? 'CUSTOM - '
      : '';
    presentationData.title = `${presentationTitleCustom}Display Banner Preview`;
    const presentation = this.state.presentation;

    // if presentation already exists (unique name is set) don't update the share link!
    presentation.url = `${shortid.generate()}${shortid.generate()}${shortid.generate()}`;
    presentation.data = JSON.stringify(presentationData);
    presentation.username = this.props.user.email;
    presentation.active = true;
    presentation.cachedquery = JSON.stringify({
      ads_ids: this.props.selectedAds,
      is_multiple_accounts: false,
      is_custom_ads: this.props.showCheckboxes
    });
    const expirationDate = new Date();
    const days = this.state.selectedWeeks;
    expirationDate.setDate(expirationDate.getDate() + days);
    presentation.createdAt = new Date();
    presentation.updatedAt = new Date();
    presentation.expiredAt = expirationDate.toISOString().split('T')[0];
    const presentationCustomName = this.props.showCheckboxes
      ? `CUSTOM - ${new Date().getTime()} `
      : '';
    presentation.name = `${presentationCustomName}Display Banner Preview`;
    presentation.queryType = 'insertPresentation';

    try {
      await this.props.actions.newPresentationImport(presentation);
      this.setState({ presentationSaved: 'new', shareLink: presentation.url });
    } catch (error) {
      console.log(error);
    }
    // this.setState({ presentation });
    // try {
    //   await this.props.submit(this.state.presentation);
    //   this.setState({ presentationSaved: 'new' });
    //   this.setState({ shareLink: this.presentation.url });
    // } catch (error) {
    //   // failed to save? do we have a collison in the name field?
    //   const updatedPresentation = await this.props.update(this.state.presentation);
    //   this.setState({ presentationSaved: 'update' });
    //   this.setState({
    //     shareLink: updatedPresentation.data.updatePresentationByName.presentation.url
    //   });
    // }
  };

  sharePDFV1 = () => {
    const ads = [];
    Object.keys(this.props.selectedAds).forEach((k) => {
      this.props.selectedAds[k].forEach((a) => {
        ads.push({
          adId: a.id,
          ad_name: a.name,
          ad_objective: k,
          formats: ['DESKTOP_FEED_STANDARD', 'MOBILE_FEED_STANDARD']
        });
      });
    });
    const fullname = getFullNameOrUserName(this.props.user);
    const data = {
      username: this.props.user.email,
      fullname,
      account_id: this.props.selectedAccounts[0].value,
      account_name: this.props.adAccountName,
      year: this.props.selectedYear,
      month: this.props.campaignMonthName,
      ads
    };
    generatePdfAsync(data);
    toast('The PDF will be emailed to you shortly!', {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 2000,
      type: toast.TYPE.SUCCESS,
      hideProgressBar: true
    });
  };

  render() {
    const { shareLink } = this.state;
    let urlString =
      shareLink !== null
        ? (urlString = `${window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname}/${shareLink}`)
        : '';
    urlString = urlString
      .replace('adImport', 'presentationsImport')
      .replace('preview', 'detail');

    return (
      <div>
        <ModalShareLink
          urlString={urlString}
          showForm={this.state.showForm}
          closeForm={this.closeForm}
        />
        <ul className="button-list">
          <li>
            <div className="custom-button">
              <Form.Button
                className="custom-button"
                size="small"
                color="green"
                onClick={() => this.customizeShareLink()}
              >
                Filter Ads
              </Form.Button>
            </div>
          </li>
          <li>
            <div className="weeks-container">
              <div className="weeks-label">Select Time</div>
              <div className="select-weeks">
                {this.state.weeksOptions &&
                  this.state.weeksOptions.length > 0 && (
                    <Dropdown
                      placeholder="Expiration"
                      selection
                      defaultValue={7}
                      options={this.state.weeksOptions}
                      onChange={this.onWeekSelect}
                    />
                  )}
              </div>
            </div>
          </li>
          <li className="button-share">
            <Form.Button
              size="small"
              floated="left"
              color="blue"
              onClick={this.submitForm}
              disabled={this.emptyAds()}
            >
              Share This Presentation
            </Form.Button>
          </li>
          {/* <li className="button-email">
            <Form.Button size="small" floated="right" color="blue" onClick={this.showEmailModal}>
              Email (Beta)
            </Form.Button>
            <Modal dimmer="inverted" open={this.state.showEmailModal} onClose={this.onCloseEmailModal}>
              <Modal.Header>Email</Modal.Header>
              <Modal.Content>
                <ModalEmail
                  originalAds={this.props.campaignMonth}
                  selectedAds={this.props.selectedAds}
                  closeModal={this.onCloseEmailModal}
                  emailTemplate={this.state.emailTemplate}
                  shareLink={urlString}
                  month={this.props.campaignMonthName}
                  user={this.props.user}
                />
              </Modal.Content>
            </Modal>
          </li> 
          <li>
            <Button onClick={this.sharePDFV1}>Share PDF (Beta)</Button>
          </li>*/}
        </ul>
        {this.state.showEmptyAdsMessage ? (
          <div className="emptyAdsMessage">
            Can not send an empty preview page
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  adImport: state.adImport
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SharePresentationEmail);



// WEBPACK FOOTER //
// ./src/screens/AdImport/AdImportComponents/SharePresentationEmail.js